export default __webpack_public_path__ + "static/media/trash.66788df6.svg";